function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.118 10.059h-.069A2.127 2.127 0 0118 11.647a2.12 2.12 0 01-2.041-1.555l-.008-.033h-.068a2.12 2.12 0 00-2.117 2.117v2.118h8.47v-2.118a2.12 2.12 0 00-2.117-2.117z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.882 0H.53A.531.531 0 000 .53v16.94c0 .292.238.53.53.53h24.352c.291 0 .53-.238.53-.53V.53a.531.531 0 00-.53-.53zM18 3.176a2.65 2.65 0 012.647 2.648A2.65 2.65 0 0118 8.47a2.65 2.65 0 01-2.647-2.647A2.65 2.65 0 0118 3.176zm-7.412 11.647H3.176a.53.53 0 110-1.058h7.412a.53.53 0 110 1.058zm0-3.176H3.176a.53.53 0 110-1.059h7.412a.53.53 0 110 1.06zm0-3.176H3.176a.53.53 0 110-1.06h7.412a.53.53 0 110 1.06zm0-3.177H3.176a.53.53 0 110-1.059h7.412a.53.53 0 110 1.06zm12.706 9.53a.53.53 0 01-.53.529h-9.529a.53.53 0 01-.53-.53v-2.646A3.18 3.18 0 0115.883 9h.069c.48 0 .895.326 1.028.812a1.06 1.06 0 002.042 0c.133-.486.547-.812 1.028-.812h.069a3.18 3.18 0 013.176 3.177v2.646z",
  fill: "#404040"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18 7.412a1.588 1.588 0 100-3.177 1.588 1.588 0 000 3.177z",
  fill: "#000"
});

function SvgIdIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgIdIcon;